<div class="db-domain-summary">
    <h1>{{'text_summaryTitle' | dbText}}</h1>
    <div class="db-domain-summary__info mt16 pb32">
      <div>
          <div>
              <span>
            {{ choosedSubscription?.title || choosedSubscription?.subscriptionTitle }}</span>
              <span>
                <ng-container *ngIf="isCurrencyBeforeAmount">
                  {{ currencySymbol }}{{
                        ((renew ? (choosedSubscription?.lifetimeCoupon && !choosedSubscription?.plan?.hasAppsumoPrice ?
                            choosedSubscription?.plan?.price : (choosedSubscription?.discountPercent ?
                                choosedSubscription?.amountWithoutDiscount : choosedSubscription?.plan?.planPrice))
                            : choosedSubscription?.plan?.priceDiscounted)) | negativeToZero
                    }}
                </ng-container>
                <ng-container *ngIf="!isCurrencyBeforeAmount">
                  {{
                        ((renew ? (choosedSubscription?.lifetimeCoupon && !choosedSubscription?.plan?.hasAppsumoPrice ? choosedSubscription?.plan?.price : (choosedSubscription?.discountPercent ? choosedSubscription?.amountWithoutDiscount : choosedSubscription?.plan?.planPrice)) : choosedSubscription?.plan?.priceDiscounted) + choosedSubscription?.plan?.additionalDomainPrice +
                            choosedSubscription?.plan?.additionalCDNPrice + choosedSubscription?.plan?.usedMultiplierAddOnPrice + choosedSubscription?.plan?.usedMultiplierRegenPrice) | negativeToZero
                    }} {{ currencySymbol }}
                </ng-container>
                <span class="period">
              {{ choosedSubscription?.plan?.periodNumber === 1 ? ('text_perMonth' | dbText) : ('text_perYear' | dbText) }}</span>
          </span>
          </div>


          <p class="opacity">{{'text_hostedWebsitesIncluded' | dbText: {count: choosedSubscription?.plan?.hostingService?.domain_count?.parameter_value} }}</p>
      </div>
        @if (choosedSubscription?.discountAmount || proRatedCredits) {
            <div class="credits-container {{choosedSubscription?.discountAmount && proRatedCredits ? 'with-border' : 'mt27'}}">
                @if (choosedSubscription?.discountAmount) {
                    <div class="credits">
                        <div class="credit">Discount</div>
                        <div class="credit-value">
                          <ng-container *ngIf="isCurrencyBeforeAmount">
                            -{{ currencySymbol }}{{ choosedSubscription?.discountAmount }}
                          </ng-container>
                          <ng-container *ngIf="!isCurrencyBeforeAmount">
                            -{{ choosedSubscription?.discountAmount }} {{ currencySymbol }}
                          </ng-container>
                        </div>
                    </div>
                }
                @if (proRatedCredits) {
                    <div class="credits">
                        <div class="credit">{{ 'text_credit' | dbText }}
                            <i class="db-icon db-icon-ds-info-lined-italic"
                               [dsTooltip]="'text_upgradingBeforePeriodEnd' | dbText"
                               dsTooltipPosition="right"
                               dsTooltipAlign="bottom"></i>
                        </div>
                        <div class="credit-value">
                          <ng-container *ngIf="isCurrencyBeforeAmount">
                            -{{ currencySymbol }}{{ Math.abs(proRatedCredits) }}
                          </ng-container>
                          <ng-container *ngIf="!isCurrencyBeforeAmount">
                            -{{ Math.abs(proRatedCredits) }} {{ currencySymbol }}
                          </ng-container>
                        </div>
                    </div>
                }
            </div>
        }
      <div class="pay-now">
          <span>{{'text_payNow' | dbText}}</span>
          <ng-container [ngTemplateOutlet]="price" [ngTemplateOutletContext]="{ calculateProRatedCredits: !!proRatedCredits }"></ng-container>
      </div>
      <p class="next-payment mt8 mb32">
        {{'text_yourNextPaymentOf' | dbText}}
        <ng-container [ngTemplateOutlet]="price" [ngTemplateOutletContext]="{ calculateProRatedCredits: false }"></ng-container>
        {{'text_willBeChargedOn' | dbText}} {{nextBillingDate | date: 'MMM d, y'}}.
      </p>
    </div>
    <ng-template #price let-calculateProRatedCredits="calculateProRatedCredits">
        <span>
          <ng-container *ngIf="isCurrencyBeforeAmount">
            {{ currencySymbol }}{{
                  ((renew ? (choosedSubscription?.lifetimeCoupon ? choosedSubscription?.plan?.price :
                      choosedSubscription?.plan?.planPrice) : choosedSubscription?.plan?.priceDiscounted))
                  + (calculateProRatedCredits ? proRatedCredits : 0) | negativeToZero | roundNumber
              }}
          </ng-container>
          <ng-container *ngIf="!isCurrencyBeforeAmount">
            {{
                  ((renew ? (choosedSubscription?.lifetimeCoupon ? choosedSubscription?.plan?.price :
                      choosedSubscription?.plan?.planPrice) : choosedSubscription?.plan?.priceDiscounted))
                  + (calculateProRatedCredits ? proRatedCredits : 0) | negativeToZero | roundNumber
              }} {{ currencySymbol }}
          </ng-container>
        </span>
    </ng-template>
</div>
